/** Canonical Operators feature routes (nested under `/operators`). */
export const OPERATORS_INDEX_PATH = "/operators" as const;
export const OPERATORS_AUTOMATIONS_PATH = "/operators/automations" as const;
export const OPERATORS_SKILLS_PATH = "/operators/skills" as const;
export const OPERATORS_SKILL_PATH = "/operators/skills/$skillId" as const;
export const OPERATORS_THREAD_PATH = "/operators/$threadId" as const;

export function isOperatorsPathname(pathname: string): boolean {
  return pathname === OPERATORS_INDEX_PATH || pathname.startsWith(`${OPERATORS_INDEX_PATH}/`);
}

export function isOperatorsIndexPathname(pathname: string): boolean {
  return pathname === OPERATORS_INDEX_PATH || pathname === `${OPERATORS_INDEX_PATH}/`;
}
